export default __webpack_public_path__ + "static/media/sort-alphabetical-ascending-hover.969718f3.svg";